<div class="inputfile-box">
    <input type="file" name="file" id="file" class="inputfile" (change)="onFileSelected($event)" #fileNameId />
    <label for="file">
        <span id="file-name" class="file-box">{{infoMsg}}</span>
        <span class="file-button">
            <mat-icon>publish</mat-icon>
            <span>{{"Select File" | translate}}</span>
        </span>
    </label>
</div>